import React from "react";

const AboutUs = () => {
  return (
    <div className="w-full text-white  font-IRANSansWeb flex flex-col  ">
      <div
        className=" bg-[#f5911e] px-20 opacity-95 flex flex-col border-2 border-[#f5911e] my-12
        screen1200:px-10 screen800:px-10 screen400:px-0 
      "
      >
        <div
          className=" p-10 text-2xl font-bold place-self-end screen800:text-[16px]   screen1800:text-[26px]
          screen800:p-6
        "
        >
          درباره ی ما
        </div>

        <div
          style={{ direction: "rtl" }}
          className=" w-full  px-10 mb-10 place-self-end text-justify screen800:text-[11px] screen800:px-6 screen800:mb-6  screen1800:text-[20px] "
        >
          سکه شادمهر از تاریخ 1385 در بمدت 16 سال در ستارخان شادمهر پلاک 207
          تاسیس و از سال 1395 با مدیریت جدید مشغول فعالیت می باشد این واحد صنفی
          زیر نظر اتحادیه طلا نقره و سکه تهران به کد 7172 می باشد
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
